import React, { useEffect, useRef } from 'react'
import slideAcross from '../utils/slide'

function Mission() {
	const slide = useRef()

	useEffect(() => {
		slideAcross([slide.current])
	}, [])

	return (
		<section className='mission'>
			<div className='mission__content'>
				<h2 className='mission__title' ref={slide} data-slide='left'>
					Misión
				</h2>
				<div className='mission__text' data-aos='fade-up' data-aos-delay='500'>
					<p>
						<span className='upper'>
							Crear y poner en valor las inversiones de nuestros clientes.
						</span>
					</p>
					<p>
						Somos una empresa de servicios que logra crear y poner en valor las inversiones de sus
						clientes, organizando, comunicando y gestinonando: clientes, cobros, pagos y diversas
						situaciones.
					</p>
					<p>
						GAIN mejora, facilita, asesora y ordena para lograr que las inversiones sean más
						rentables, cuidando al cliente para facilitar el cumplimiento del contrato. ¡GAIN SE
						OCUPA!
					</p>
				</div>
			</div>
		</section>
	)
}

export default Mission
